import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Browsers restore the previous scroll position on reload, which lands you
// mid-page — and here it also means missing the name being written. Opt out,
// but leave deep links to a section (#work) alone.
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
if (!window.location.hash) {
  window.scrollTo(0, 0);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
